// Lenient UUID matcher (accepts any version/variant — Supabase ids must round-trip,
// so don't reject a valid db uuid over a version nibble). Case-insensitive.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** True only for a string shaped like a UUID. Non-strings (undefined/null/number) → false. */
export function isUuid(v: unknown): boolean {
  return typeof v === 'string' && UUID_RE.test(v)
}

/**
 * True when a `/patients/:id/...` route carries an `:id` segment that is NOT a uuid
 * (e.g. the literal "undefined"/"null" from a navigation built with a missing id).
 *
 * Used by `middleware/05.patient-id-guard.global.ts` to redirect BEFORE the page
 * mounts and every store fires `id=eq.undefined` → Postgres 22P02 (Sentry noise).
 * Routes without an `:id` param (`/patients`, `/patients/create`, `/patients/intake/*`)
 * resolve to their own static pages, so `id` is undefined there → returns false (leave alone).
 */
export function isInvalidPatientIdRoute(path: string, id: unknown): boolean {
  if (!path.startsWith('/patients/')) return false
  if (typeof id !== 'string' || id === '') return false
  return !isUuid(id)
}
